import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RatesFilterStateService } from '../../state/rates-filter-state.service';
import { POPOVER_CONTEXT, PickerComponent } from './picker.types';
import { pickerRegistry } from './picker-registry';

const MAX_CONTRIBUTION = 10_000_000;

@Component({
  selector: 'app-numeric-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './numeric-picker.component.html',
  styleUrl: './numeric-picker.component.scss',
})
export class NumericPickerComponent implements PickerComponent {
  protected readonly ctx = inject(POPOVER_CONTEXT);
  protected readonly filterState = inject(RatesFilterStateService);

  protected readonly displayValue = computed<string>(() => {
    this.filterState.version();
    const n = this.filterState.activeSlot().contributionAmount;
    return n != null ? n.toLocaleString('en-US') : '';
  });

  onInput(input: HTMLInputElement): void {
    const raw = input.value.replace(/[^0-9]/g, '');
    const num = raw === '' ? null : Math.min(Number(raw), MAX_CONTRIBUTION);
    this.filterState.setSlotField('contributionAmount', num);
    this.filterState.requestApplyFilters();
    input.value = num != null ? num.toLocaleString('en-US') : '';
  }

  clearAll(): void {
    this.filterState.clearAppliedDimension(this.ctx.dimensionKey);
    this.filterState.requestApplyFilters();
  }
}

pickerRegistry['contribution'] = {
  component: NumericPickerComponent,
  label: 'Premium',
  field: 'contributionAmount',
  group: 'Features',
};
